import type { CampaignFilters } from '@/services/crmCampaignsService'

const TIME_ZONE = 'Europe/Madrid'

export function formatDateTime(value: string | null | undefined, lang: string): string {
  if (!value) return '—'
  return new Intl.DateTimeFormat(lang, {
    timeZone: TIME_ZONE,
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value))
}

/** Con el día de la semana: «lun, 9 nov 2026» se comprueba de un vistazo; «09/11» no. */
export function formatDay(value: string | Date, lang: string): string {
  return new Intl.DateTimeFormat(lang, {
    timeZone: TIME_ZONE,
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(typeof value === 'string' ? new Date(value) : value)
}

export function formatNumber(value: number, lang: string): string {
  return new Intl.NumberFormat(lang).format(value)
}

/** Hoy en Madrid como `YYYY-MM-DD`, que es lo que entiende `<input type="date">`. */
export function todayInMadrid(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: TIME_ZONE }).format(now)
}

/** El día de `value` en Madrid: dos envíos del mismo día se agrupan aunque en UTC no lo sean. */
export function dayKey(value: string): string {
  return todayInMadrid(new Date(value))
}

/** DRF devuelve `09:00:00`; `<input type="time">` y las comparaciones van con `09:00`. */
export function toTimeInput(value: string | null | undefined): string {
  return (value ?? '').slice(0, 5)
}

export function sumValues(values: Record<string, number> | undefined): number {
  return Object.values(values ?? {}).reduce((total, value) => total + value, 0)
}

export const DEFAULT_FILTERS: CampaignFilters = { estados: ['Activa'] }

/** Los filtros tal como se guardan: sin listas vacías ni números sin rellenar. */
export function compactFilters(filters: CampaignFilters): CampaignFilters {
  const entries = Object.entries(filters).filter(([, value]) => {
    if (value === null || value === undefined || value === '') return false
    return !(Array.isArray(value) && value.length === 0)
  })
  return Object.fromEntries(entries) as CampaignFilters
}
